import { Loader2 } from "lucide-react"
import { SubscriptionLog } from "../../../../../types"
import { useFetchSubscriptionDetailsQuery } from "../../../../../redux/queries"
import If from "../../../if"

interface Props {
  info: SubscriptionLog
  openLink: (link: string) => void
}

const ViewDashboardCell: React.FC<Props> = ({ info, openLink }) => {
  const { data } = useFetchSubscriptionDetailsQuery({ id: info.id })

  return (
    <td className="view-dashboard-cell relative whitespace-nowrap py-4 px-0 text-right text-sm cursor-pointer sm:pr-6 pl-3 md:pr-4 hidden md:table-cell">
      <If
        condition={!data}
        then={
          <Loader2
            className="animate-spin h-6 w-6 text-primary-alt-400 mx-auto"
            aria-hidden="true"
          />
        }
        else={
          <span
            className="pb-1 border-b border-dotted border-neutral-400  invisible group-hover:visible"
            onClick={() => openLink(data?.dashboard_link ?? "")}
          >
            View Lead dashboard
          </span>
        }
      />
    </td>
  )
}
export default ViewDashboardCell
